<template>
	<div class="dropdown-body">
		<p class="text-secondary font-w-600 mb-2">Leasingdetails</p>
		<table class="table table-price-details">
			<tbody>
				<tr>
					<td class="label">
						{{ getPrice(this.$store.state.price.leasing.period) }} Monate à
					</td>
					<td class="text-end text-secondary rate">
						{{ getPrice(leasing.grossRate) }} €
					</td>
				</tr>
				<tr>
					<td class="label">Fahrleistung (jährlich)</td>
					<td class="text-end">
						{{ getPrice(this.$store.state.price.leasing.mileage) }} Km
					</td>
				</tr>
				<tr>
					<td class="label">Fahrzeugpreis</td>
					<td class="text-end">{{ getPrice(car.consumerPriceGross) }} €</td>
				</tr>
				<tr>
					<td class="label">Leasing-Gesamtbetrag</td>
					<td class="text-end">
						{{
							getPrice(
								leasing.grossRate * this.$store.state.price.leasing.period
							)
						}}
						€
					</td>
				</tr>
				<tr>
					<td class="label">Effektiver Jahreszins</td>
					<td class="text-end">{{ leasing.annualPercentageRate }} %</td>
				</tr>
				<tr>
					<td class="label">Sollzins (geb.)</td>
					<td class="text-end">{{ leasing.nominalInterestRate }} %</td>
				</tr>
			</tbody>
		</table>
		<p class="font-w-600 mb-2 text-secondary">Kosten</p>
		<table class="table table-price-details">
			<tbody>
				<tr>
					<td class="label">Sonderzahlung (einmalig)</td>
					<td class="text-end">{{ getPrice(leasing.downPayment) }} €</td>
				</tr>
				<tr>
					<td class="label">Zulassungskosten (einmalig)</td>
					<td class="text-end">{{ getPrice(leasing.registrationFees) }} €</td>
				</tr>
				<tr>
					<td class="label">Bereitstellungskosten (einmalig)</td>
					<td class="text-end">{{ getPrice(leasing.destinationCharges) }} €</td>
				</tr>
				<tr>
					<td class="label">Mehrkilometer</td>
					<td class="text-end">{{ leasing.extraMileageCosts }} €</td>
				</tr>
				<tr>
					<td class="label">Minderkilometer</td>
					<td class="text-end">{{ leasing.lowMileageCompensation }} €</td>
				</tr>
			</tbody>
		</table>
		<p class="text-muted font-12 text-wrap">
			{{ getLegalTextLeasingDetails(leasing.downPayment, leasing.bank) }}
		</p>
	</div>
</template>

<script>
export default {
	name: 'DetailsDropdownPriceLeasing',
	props: {
		car: {
			type: Object,
			required: true,
		},
		leasing: {
			type: Object,
			required: true,
		},
	},
}
</script>

<style lang="scss"></style>
